import { IListarClientesVendas } from "../../../Interfaces/Cobranca/Proponentes/ProponentesInterfaces";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ListarClientesVendaServices(
    idChaveErp: string | undefined
) {
    return Service(
        Axios.get<Array<IListarClientesVendas>>(
            `/cobranca/buscacliente/listarclientesvenda?idChaveErp=${idChaveErp}`
        )
    );
}
